export const getFontWeight = (size) => {
  switch (size) {
    case "Heavy" || "heavy":
      return "font-weight: 700";

    case "Medium" || "medium":
      return "font-weight: 500";

    case "Light" || "light":
      return "font-weight: 300";

    default:
      return "font-weight: 500";
  }
};
